import { Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApiService } from '../api/api.service';
import { ApiWebSocketService } from '../api/api.web-socket.service';
import { login, logout } from '../store/auth/auth.actions';

export function saveTokens(
  tokens: object | any,
  wsService?: ApiWebSocketService
): boolean {
  console.log('setTokens');
  if (wsService) {
    wsService.refreshWebsocketToken(tokens.accessToken);
  }
  Object.keys(tokens).forEach((field: string) => {
    localStorage.setItem(field, tokens[field]);
  });
  return true;
}

export function checkTokens(
  type: 'resume' | 'login',
  store: Store,
  api: ApiService,
  router: Router,
  query?: Params
): boolean {
  if (localStorage['accessToken'] && localStorage['refreshToken']) {
    if (new Date(+localStorage['expirationAccessToken']) > new Date()) {
      store.dispatch(login({ status: 'authorized' }));
      if (type === 'login') {
        return true;
      } else {
        router.navigate(['/city', { id: 1 }]);
      }
    } else {
      if (new Date(+localStorage['expirationRefreshToken']) > new Date()) {
        api
          .auth('refresh', localStorage['refreshToken'])
          .subscribe((res): boolean | any => {
            if (res) {
              saveTokens(res);
              router.navigate(['/city', { id: 1 }]);
            }
          });
      } else {
        console.log('res', type);
        store.dispatch(logout());
      }
    }
  }
  // if (type === 'resume') {
  //   localStorage.clear();
  // }
  if (type === 'login') {
    if (query?.accessToken) {
      if (saveTokens(query)) {
        console.log('here');
        location.replace('/city;id=1');
        return true;
      } else {
        store.dispatch(login({ status: 'unauthorized' }));
      }
    }
    return false;
  } else {
    return true;
  }
}
